// Keep dialogs and the app inside the visible viewport when the keyboard opens.
// Pinch zoom remains a browser action: do not resize the app while zooming.
export function installViewportSync(win = window, doc = document) {
  let frame = 0;
  const viewport = win.visualViewport;
  const sync = () => {
    frame = 0;
    if (viewport && viewport.scale !== 1) return;
    const height = viewport?.height || win.innerHeight;
    const offset = viewport?.offsetTop || 0;
    doc.documentElement.style.setProperty('--app-height', `${Math.round(height)}px`);
    doc.documentElement.style.setProperty('--app-offset-top', `${Math.round(offset)}px`);
    const editing = doc.activeElement?.matches('input:not([type="checkbox"]):not([type="radio"]), textarea, [contenteditable="true"]');
    doc.documentElement.classList.toggle('keyboard-open', Boolean(editing && win.innerHeight - height > 150));
  };
  const schedule = () => { if (!frame) frame = win.requestAnimationFrame(sync); };
  const events = [[win, 'resize'], [win, 'orientationchange'], [win, 'pageshow'],
    [doc, 'focusin'], [doc, 'focusout'], [viewport, 'resize'], [viewport, 'scroll']];
  events.forEach(([target, type]) => target?.addEventListener(type, schedule, { passive: true }));
  sync();
  return () => {
    events.forEach(([target, type]) => target?.removeEventListener(type, schedule));
    if (frame) win.cancelAnimationFrame(frame);
  };
}
